<ng-select
  *ngIf="shown"
  style="width: 80px;"
  [clearable]="false"
  [items]="steps"
  [ngModel]="itemsPerPage"
  (change)="itemsPerPageChange($event)"
></ng-select>
